import { render, staticRenderFns } from "./BAddDialog.vue?vue&type=template&id=01f245e0&scoped=true"
import script from "./BAddDialog.vue?vue&type=script&lang=js"
export * from "./BAddDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f245e0",
  null
  
)

export default component.exports